"use client";

import React from "react";
import { ArrowRight, Terminal } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function CallToAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="228378" id="get-started-cta" className="relative w-full min-h-[80vh] flex items-center justify-center overflow-hidden py-32 !bg-[rgba(7,82,82,1)] !text-[rgba(148,224,213,1)]">
      {}
      <div className="absolute inset-0 opacity-[0.08] pointer-events-none mix-blend-overlay z-0" style={{
      backgroundImage: 'url("data:image/svg+xml,%3Csvg viewBox=%220 0 200 200%22 xmlns=%22http://www.w3.org/2000/svg%22%3E%3Cfilter id=%22noiseFilter%22%3E%3CfeTurbulence type=%22fractalNoise%22 baseFrequency=%220.8%22 numOctaves=%223%22 stitchTiles=%22stitch%22/%3E%3C/filter%3E%3Crect width=%22100%25%22 height=%22100%25%22 filter=%22url(%23noiseFilter)%22/%3E%3C/svg%3E")'
    }} aria-hidden="true" />

      {}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none z-0 overflow-hidden" aria-hidden="true">
        <span className="text-[14vw] font-default font-bold text-white/[0.02] tracking-tighter whitespace-nowrap">
          TRANSFORM
        </span>
      </div>

      {}
      <div ref={ref} className="relative z-10 w-full h-full">
        <svg className="absolute inset-0 w-full h-full pointer-events-none z-0" aria-hidden="true">
          {}
          <line x1="5%" y1="0" x2="5%" y2="100%" className="stroke-white/10 stroke-[1px] transition-all duration-[1500ms] ease-in-out" style={{
          strokeDasharray: "2000",
          strokeDashoffset: isVisible ? "0" : "2000"
        }} />
          {}
          <line x1="95%" y1="0" x2="95%" y2="100%" className="stroke-white/10 stroke-[1px] transition-all duration-[1500ms] ease-in-out delay-100" style={{
          strokeDasharray: "2000",
          strokeDashoffset: isVisible ? "0" : "2000"
        }} />
          {}
          <line x1="0" y1="10%" x2="100%" y2="10%" className="stroke-white/10 stroke-[1px] transition-all duration-[1500ms] ease-in-out delay-200" style={{
          strokeDasharray: "3000",
          strokeDashoffset: isVisible ? "0" : "3000"
        }} />
          {}
          <line x1="0" y1="90%" x2="100%" y2="90%" className="stroke-white/10 stroke-[1px] transition-all duration-[1500ms] ease-in-out delay-300" style={{
          strokeDasharray: "3000",
          strokeDashoffset: isVisible ? "0" : "3000"
        }} />
        </svg>

        {}
        <div className="relative z-20 container mx-auto px-6 md:px-12 flex flex-col items-center text-center">
          {}
          <div className={cn("flex flex-col items-center gap-10 transition-all duration-1000 ease-[cubic-bezier(0.22,1,0.36,1)]", isVisible ? "opacity-100 translate-y-0 scale-100" : "opacity-0 translate-y-16 scale-95")}>
            <h2 className="font-default font-bold tracking-tight text-white max-w-4xl leading-tight !text-5xl !h-[120px]">Bereit für deine<span className="text-white/90 block mt-4" data-ast-id="f:/src/pages/SolutionsSubpagesPage2/sections/CallToAction.tsx|sig:gqtopx" data-ast-start="3144" data-ast-end="3209" contenteditable="false" style={{}}>Transformation?</span></h2>

            <p className="text-2xl max-w-2xl text-secondary !font-sans !not-italic !font-bold md:text-[32px]">Nutze jetzt unser Kennenlern-Angebot: <br />Probebehandlung für nur 49 Euro!</p>

            <div className="flex flex-col sm:flex-row items-center gap-6 mt-4">
              <div className="mt-8 flex justify-center w-full">
                <div className="zeeg-inline-widget w-full max-w-2xl" id="zeeg-embed-bodyconcept-by-linda-bewei-body" style={{
                minWidth: "320px",
                minHeight: "780px"
              }}></div>
                <script type="text/javascript" src="https://assets.zeeg.me/embed.min.js" data-user="bodyconcept-by-linda" data-event-type="bewei-body" data-redirect-parent="true" async></script>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}